import { Link } from 'ui';

export const TermsAndPolicyAgreement = () => {
  return (
    <span>
      I accept the&nbsp;
      <Link href="https://www.safi.co/terms" target="_blank">
        Terms & Conditions
      </Link>
      &nbsp;and the&nbsp;
      <Link href="https://www.safi.co/privacy-policy" target="_blank">
        Privacy Policy
      </Link>
      &nbsp;by joining Safi.
    </span>
  );
};
